<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	//Design system components
	import { Text, Token, Loader } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { Device } from 'src/types/Device';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let device: Device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id),
		save = async () => {
			waitForResponse = true;
			const res: SettingRequest = await gen2Request(device, 'sys.SetConfig', {
				config: { ui_data: { temperature_unit: selected } },
			});
			onSettingsResponse(res, device);
			waitForResponse = false;
		};

	let selected = settings?.sys?.ui_data?.temperature_unit || 'C',
		waitForResponse = false;
</script>

<Text styleType="body-small" class="mb-s">
	{$format('select_temperature_units', {
		default: 'Choose temperature units:',
	})}
</Text>

<div
	class={classMap({
		'd-flex': true,
		'justify-content-center': waitForResponse,
	})}
>
	{#if waitForResponse}
		<Loader size="m" class="align-self-center" />
	{:else}
		<Token
			id="token-0mdyord"
			selected={selected === 'C'}
			size="m"
			title="°C"
			class="mr-s"
			on:click={() => {
				selected = 'C';
				save();
			}}
		/>
		<Token
			id="token-4dhfvzk"
			selected={selected === 'F'}
			size="m"
			title="°F"
			on:click={() => {
				selected = 'F';
				save();
			}}
		/>
	{/if}
</div>
